import { helpers, required, email as emailValidator } from '@vuelidate/validators';
import { trans } from '../../../../_00_elements/translation';

const regexValidator = (regex, messageKey) => helpers.withMessage(() => trans(messageKey), helpers.regex(regex));

const requiredValidator = (messageKey) => helpers.withMessage(() => trans(messageKey), required);

const nullableEmailValidator = helpers.withMessage(
  () => trans('gestion.pay.informations.email.error.invalid'),
  (value) => {
    if (!value) {
      return true;
    }
    return emailValidator.$validator(value);
  },
);

// eslint-disable-next-line import/prefer-default-export
export const commonPayAccountRules = {
  legal_name: {
    required: requiredValidator('gestion.pay.informations.company.error.required'),
  },
  street_and_number: { required: requiredValidator('gestion.pay.informations.street_and_number.error.required') },
  additional_info: {},
  zip_code: {
    required: requiredValidator('gestion.pay.informations.zip_code.error.invalid'),
    zipCode: regexValidator(/^\d{5}$/, 'gestion.pay.informations.zip_code.error.invalid'),
  },
  city: { required: requiredValidator('gestion.pay.informations.city.error.required') },
  siren: {
    required: requiredValidator('gestion.pay.informations.siren.error.invalid'),
    siren: regexValidator(/^\d{9}$/, 'gestion.pay.informations.siren.error.invalid'),
  },
  vat_number: {
    required: requiredValidator('gestion.pay.informations.vat.error.invalid'),
    vatNumber: regexValidator(/^FR[A-Z0-9]{2}\d{9}$/, 'gestion.pay.informations.vat.error.invalid'),
  },
  email: {
    required: requiredValidator('gestion.pay.informations.email.error.required'),
    email: nullableEmailValidator,
  },
};
